export interface Author {
  name: string;
  displayName?: string;
  avatarUrl: string;
  href?: string;
}

const authors: Record<string, Author> = {
  rebolt: {
    name: "Rebolt Team",
    avatarUrl: "/rebolt-branding/rebolt-app-icon.png",
  },
  arwin: {
    name: "Arwin Rahmatpanah",
    avatarUrl:
      "https://images.ctfassets.net/x2owjp2edpyy/4NXoAgmBRU0z17BK5NNaou/94be7835118e880e0e9267f03d08de0c/arwin.jpeg",
  },
  will: {
    name: "Will Wallace",
    avatarUrl: "/will.png",
  },
} as const;

export default authors;
